export const keywordsConstants = {
    KEYWORDS_SUCCESS: 'KEYWORDS_SUCCESS',
    KEYWORDS_ERROR: 'KEYWORDS_ERROR',
    KEYWORDS_REQUEST: 'KEYWORDS_REQUEST',
    KEYWORDS_ALL_SUCCESS: 'KEYWORDS_ALL_SUCCESS',
};
